import apiAxios from '@/services/axiosConfig';
import type { Connection, CreateConnectionRequest } from '@/types/api';

async function createConnection(data: CreateConnectionRequest): Promise<Connection> {
  const response = await apiAxios.post<Connection>('/api/v1/mt/connections', data);
  return response.data;
}

export default createConnection;
